module.exports = __webpack_public_path__ + "media/authors/kathryn-randolph-horizontal-c4ef9507.jpg";